import React from "react";
import "./RestronName.css";

const cities = [
  "Delhi",
  "Mumbai",
  "Kolkata",
  "Chennai",
  "Bengaluru",
  "Hyderabad",
  "Ahmedabad",
  "Pune",
  "Jaipur",
  "Lucknow",
  "Chandigarh",
  "Bhopal",
  "Indore",
  "Patna",
  "Nagpur",
  "Surat",
  "Visakhapatnam ",
  "Coimbatore",
];

const RestronName = () => {
  return (
    <div className="main">
      {cities.map((city, index) => (
        <div key={index} className="restaurant-name">
          {city.toUpperCase()} RESTAURANT
        </div>
      ))}
    </div>
  );
};

export default RestronName;
